import React from 'react'
import { useAuth } from '../../contexts/AuthContextLazy'

import { ClientDashboard } from './dashboards/ClientDashboard'
import { StaffDashboard } from './dashboards/StaffDashboard'
import { AdminDashboard } from './dashboards/AdminDashboard'

export const Dashboard: React.FC = () => {
  const { userProfile } = useAuth()

  // Route to appropriate dashboard based on user role
  switch (userProfile?.role) {
    case 'super_admin':
      return <AdminDashboard />;
    case 'pcm_staff':
      return <StaffDashboard />;
    case 'client_user':
    case 'client_admin':
      return <ClientDashboard />;
    default:
      // Show loading state while role is being determined
      return (
        <div className="flex items-center justify-center h-full">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      );
  }

}